<template>
    <div>
        <ul
            class="list-group list-group-flush"
            v-for="(node, idx) in nodes"
            :key="getkey(node, idx)"
        >
            <li
                class="list-group-item d-flex justify-content-between"
                @click="node.collapsed = !node.collapsed"
            >
                <div>{{ node.name }}</div>
                <span>
                    <i
                        class="fa"
                        :class="node.collapsed ? 'fa-chevron-down' : 'fa-chevron-up'"
                        aria-hidden="true"
                    ></i>
                </span>
            </li>
            <transition name="collapse">
                <ul
                    v-show="!node.collapsed"
                    class="list-group list-group-flush"
                    v-if="node.children"
                >
                    <RecursiveTreeGroupedLinks
                        class="space-left"
                        v-for="(child, idxChild) in node.children"
                        :key="`RecursiveTreeGroupedLinks-${child?.id ?? '1'}-${idxChild}`"
                        v-if="child.behavior == 'group'"
                        :nodes="[child]"
                    >
                    </RecursiveTreeGroupedLinks>
                    <a
                        v-for="(child, idxChild) in node.children"
                        :key="`list-group-item-${child?.id ?? '1'}-${idxChild}`"
                        v-if="child.url || child.filename"
                        :href="child.url ? child.url : getFormatUrlAPI(child.filename)"
                        target="_blank"
                        class="list-group-item"
                    >
                        {{ child.name }}
                    </a>
                </ul>
            </transition>
        </ul>
    </div>
</template>

<script type="text/javascript">
import GlobalMixin from "@/app/shared/mixins/global";
export default {
    name: "RecursiveTreeGroupedLinks",
    mixins: [GlobalMixin],
    components: {},
    props: {
        nodes: {
            type: Array,
            required: true
        }
    },
    data() {
        return {};
    },
    mounted() {},
    computed: {},
    methods: {
        getkey(node, idx) {
            return `list-group-${node?.id ?? "1"}-${idx}`;
        }
    }
};
</script>

<style lang="scss" scoped>
@import "@styles/_theme.scss";
.space-left {
    padding-left: 0.875rem;
}
.list-group {
    .list-group-item {
        cursor: pointer;
        padding: 0.4rem 0 0.4rem 0.75rem;
        font-family: $city-bold-font-family;
    }
    > li.list-group-item {
        padding-left: 0;
    }

    a.list-group-item {
        font-family: $city-font-family;
        font-size: 0.875rem;
    }
}
.collapse-enter-active,
.collapse-leave-active {
    transition: all 0.55s ease;
    overflow: hidden;
}

.collapse-enter,
.collapse-leave-to {
    opacity: 0;
    max-height: 0;
}

.collapse-enter-to,
.collapse-leave {
    opacity: 1;
    max-height: 9999px;
}
</style>
